<template>
  <div>
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <h3 class="mr-4">Campaigns</h3>
        <p class="mt-5">
          This is the list of marketing campaigns. Each campaign contains a series of venue campaigns.
        </p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            ref="createButton"
            id="create-button"
            class="vs-con-loading__container"
            @click="onClickCreateNew"
            type="relief"
            vslor="primary"
            v-if="$AuthService.hasPermission('vp.crm.campaigns.edit')"
            >Create campaign</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <!-- <h3>{{ activeVenue.name }}</h3> -->
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        search
        :data="masterCampaigns"
        @selected="onClicked(selected.id)"
      >
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <div class="flex flex-wrap-reverse items-center data-list-btn-container">
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Campaign name</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Number of venues</vs-th>
          <vs-th>VM fill out by</vs-th>
          <vs-th>Send by</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.title }}
                </p>
              </vs-td>
              <vs-td>
                <vs-chip :color="masterStatusObject(tr.masterStatus).color">
                  <b>{{ masterStatusObject(tr.masterStatus).text }}</b>
                </vs-chip>
              </vs-td>
              <vs-td>
                <vs-chip color="primary" class="product-order-status">
                  {{ tr.venues.length }}
                </vs-chip>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ moment(tr.approvedByDate).format("DD-MM-yyyy") }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  <vs-chip v-if="moment(tr.sendByDate).isBefore()" color="danger">
                    {{ moment(tr.sendByDate).format("DD-MM-yyyy") }}
                  </vs-chip>
                  <span v-else>
                    {{ moment(tr.sendByDate).format("DD-MM-yyyy") }}
                  </span>
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  components: {},
  mixins: [campaignMixin],
  data() {
    return {
      moment,
      newMessageTitle: "",
      selected: [],
    };
  },
  methods: {
    async onClickCreateNew() {
      var result = await this.$store.dispatch("masterCampaigns/create", { title: "New campaign" }); // TODO Title
      console.log(result);
      this.$router.push({ name: "crm-campaign", params: { id: result } }).catch(() => {});
    },
    onClicked(id) {
      this.$router
        .push({
          name: "crm-campaign",
          params: {
            id,
          },
        })
        .catch(e => {});
    },
  },
  computed: {
    ...mapGetters({
      masterCampaigns: "masterCampaigns/all",
    }),
  },

  async created() {
    await this.$store.dispatch("masterCampaigns/getAll");
  },
};
</script>

<style lang="scss">
</style>
